var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"welWord welWord1"},[_vm._v("欢迎参观")]),_c('div',{staticClass:"welWord welWord2"},[_vm._v(_vm._s(_vm.welMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }